/* eslint-env node */

import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import radio from 'radio';

import {
    addHeaderRequestInterceptor,
    get,
} from '../services/jsonfetchservice.js';
import responseMapper from './responseMapper.js';
import SmallError from './errors/smallError.jsx';
import SafeTradeRoutes from './safeTradeApp.jsx';
import rootReducerBuyer from './buyer/reducer.js';
import rootReducerSeller from './seller/reducer.js';

export default function(root) {
    const itemType = root.getAttribute('data-item-type') || 'ad';
    const itemId = root.getAttribute('data-item-id');
    const partnerId =
        Number(root.getAttribute('data-partner-id')) ||
        Number(root.getAttribute('data-counterpart-id'));

    addHeaderRequestInterceptor(() => ({
        'x-location': window.location.href,
    }));

    get(`/safe-trade/${itemType}/${itemId}/${partnerId}.json`)
        .then(response => response.json())
        .then(data => {
            if (!data.canUseTrade) {
                return;
            }

            const role = data.user.role;
            if (!role) {
                throw new Error('Unable to load safe trade without a role');
            }

            const initialState = responseMapper(
                data,
                partnerId,
                itemType,
                itemId
            );

            const reducer =
                role === 'BUYER' ? rootReducerBuyer : rootReducerSeller;
            const composeEnhancers =
                window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
            const store = createStore(
                reducer,
                initialState,
                composeEnhancers(applyMiddleware(thunk))
            );

            ReactDOM.render(
                <Provider store={store}>
                    <SafeTradeRoutes role={role} />
                </Provider>,
                root
            );
        })
        .catch(e => {
            ReactDOM.render(
                <div className="centerify">
                    <div className="r-size3of5 inlineblockify">
                        <SmallError>
                            <p className="centerify">
                                Trygg betaling er ikke tilgjengelig akkurat nå.
                                Prøv igjen om litt.
                            </p>
                        </SmallError>
                    </div>
                </div>,
                root
            );

            if (typeof window.trackJs !== 'undefined') {
                window.trackJs.track(e);
            } else if (process.env.NODE_ENV !== 'production') {
                console.error(e);
            }
        });

    function toggleGlobalFooter(enable) {
        const footer = document.getElementById('finnlet-footer');
        if (footer) {
            footer.classList[enable ? 'remove' : 'add']('hidden');
        }
    }

    radio('safe-trade-open').subscribe(() => {
        toggleGlobalFooter(false);
    });
    radio('safe-trade-close').subscribe(() => {
        toggleGlobalFooter(true);
    });
}



// WEBPACK FOOTER //
// ./safeTrade/safeTradeReactController.jsx